// Campus photo for /colleges/barnard-college: CC BY 4.0, by Jim.henderson, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABarnard_College_WDNY_2024_jeh.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/barnard-college/; credited under the photo.
const photo = {
    "slug": "barnard-college",
    "alt": "Brick buildings of Barnard College seen from the street in Morningside Heights, Manhattan",
    "src": "/colleges/barnard-college/campus-1600.webp",
    "srcSmall": "/colleges/barnard-college/campus-800.webp",
    "srcMid": "/colleges/barnard-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/barnard-college/og.jpg",
    "title": "Barnard College WDNY 2024 jeh",
    "author": "Jim.henderson",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABarnard_College_WDNY_2024_jeh.jpg",
    "read": "2026-10-01"
};

export default photo;
